<template>
    <div class="pa-5 compact-form" v-if="activeProduct">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="4">{{ "Planned production time (1 box)" | t }}</v-col>
            <v-col cols="1">
                <v-text-field
                        v-model="hours"
                        @input="updatePlannedTime"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                        type="number"
                        min="0"
                        max="99"
                />
            </v-col>
            <span class="mt-2 px-2">:</span>
            <v-col cols="1">
                <v-text-field
                        v-model="minutes"
                        @input="updatePlannedTime"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                        type="number"
                        min="0"
                        max="59"
                />
            </v-col>
            <span class="mt-2 px-2">:</span>
            <v-col cols="1">
                <v-text-field
                        v-model="seconds"
                        @input="updatePlannedTime"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                        type="number"
                        min="0"
                        max="59"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Planned production time (1 unit)" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ formattedUnitTime }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "../../../store";

export default {
    name: "general-info-edit-tab",
    data() {
        return {
            hours: "00",
            minutes: "00",
            seconds: "00"
        };
    },
    computed: {
        ...mapState("ProductStore", ["activeProduct"]),
        formattedUnitTime() {
            if (!this.activeProduct.group_package_planned_time_for_production || !this.activeProduct.bags_in_box) return "-";
            return this.formatPlannedTime(this.activeProduct.group_package_planned_time_for_production / this.activeProduct.bags_in_box);
        }
    },
    watch: {
        "activeProduct.group_package_planned_time_for_production": {
            immediate: true,
            handler(newVal) {
                if (!newVal) return;
                const { hours, minutes, seconds } = this.parseSecondsToTime(newVal);
                this.hours = hours;
                this.minutes = minutes;
                this.seconds = seconds;
            }
        }
    },
    methods: {
        updatePlannedTime() {
            const totalSeconds = this.parseTimeToSeconds(this.hours, this.minutes, this.seconds);
            Store.commit("ProductStore/updateActiveProductProperty", {
                prop: "group_package_planned_time_for_production",
                value: totalSeconds
            });
        },
        formatPlannedTime(timeInSeconds) {
            if (!timeInSeconds) return "00:00:00";
            const { hours, minutes, seconds } = this.parseSecondsToTime(timeInSeconds);
            return `${ hours }:${ minutes }:${ seconds }`;
        },
        parseTimeToSeconds(hours, minutes, seconds) {
            return (parseInt(hours) || 0) * 3600 + (parseInt(minutes) || 0) * 60 + (parseInt(seconds) || 0);
        },
        parseSecondsToTime(sec) {
            const hours = Math.floor(sec / 3600).toString().padStart(2, "0");
            const minutes = Math.floor((sec % 3600) / 60).toString().padStart(2, "0");
            const seconds = Math.round(sec % 60).toString().padStart(2, "0");
            return { hours, minutes, seconds };
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
</style>
